import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ContentWrapper, NotificationBannerWrapper } from "./styles";
import { IconCheck, IconClose, IconCloseCircle, IconInfo, IconWarning, } from "../icons";
var BANNER_OPTIONS = {
    success: {
        color: "green",
        icon: _jsx(IconCheck, {}),
    },
    warning: {
        color: "yellow",
        icon: _jsx(IconWarning, {}),
    },
    error: {
        color: "red",
        icon: _jsx(IconCloseCircle, {}),
    },
    info: {
        color: "blue",
        icon: _jsx(IconInfo, {}),
    },
};
export var NotificationBanner = forwardRef(function NotificationBanner(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "info" : _b, onClose = _a.onClose, isOpen = _a.isOpen, children = _a.children, props = __rest(_a, ["variant", "onClose", "isOpen", "children"]);
    return (_jsxs(NotificationBannerWrapper, __assign({ ref: ref, color: BANNER_OPTIONS[variant].color, "$isOpen": isOpen }, props, { children: [BANNER_OPTIONS[variant].icon, _jsx(ContentWrapper, { children: children }), !!onClose && (_jsx(IconClose, { className: "close-icon", onClick: function () { return onClose(); } }))] })));
});
//# sourceMappingURL=index.js.map